/* eslint-disable */
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Stack,
  Snackbar,
  Alert,
  Paper,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ThaiQrPayment from '../../assets/images/thai_qr_payment.png';

const LinkCashier = ({ language = 'TH', companyName }) => {
  const location = useLocation();
  const { qrCodeImage, paymentRefId, orderId, payment_url } =
    location.state || {};

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCopy = () => {
    if (payment_url) {
      navigator.clipboard.writeText(payment_url).then(() => {
        setOpenSnackbar(true);
      });
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  return (
    <Box
      sx={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '24px',
        borderRadius: '15px',
        backgroundColor: '#fff',
        boxShadow: 3,
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        gutterBottom
        sx={{ textAlign: 'center' }}
      >
        {language === 'TH' ? 'สร้างลิงก์ชำระเงิน' : 'Pay via QR Code'}
      </Typography>

      <Paper
        sx={{
          padding: 3,
          borderRadius: 2,
          backgroundColor: '#f9f9f9',
          boxShadow: 1,
          mt: 2,
        }}
      >
        <Stack spacing={2} alignItems="center" justifyContent="center">
          <Typography
            variant="body1"
            sx={{ wordBreak: 'break-all', textAlign: 'center' }}
          >
            {payment_url}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={handleCopy}
            startIcon={<ContentCopyIcon />}
          >
            คัดลอกลิงก์
          </Button>
        </Stack>
      </Paper>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: '100%' }}
        >
          คัดลอกลิงก์แล้ว!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LinkCashier;
